import React from 'react';
var loadingStyles = {
  display: 'flex',
  height: '100%',
  width: '100%',
  justifyContent: 'center',
  alignItems: 'center'
};

function Loading(_ref) {
  var content = _ref.content;
  return /*#__PURE__*/React.createElement("div", {
    style: loadingStyles
  }, content);
}

export default Loading;